import { Button } from "@mui/material";
import { createTheme, styled, ThemeProvider } from "@mui/material/styles";
import { useEffect } from "react";
import { Route, Routes } from "react-router";
import { ToastContainer } from "react-toastify";
import appstore from "../src/store/appstore";
import "./App.css";
import AdminDashboard from "./components/adminDashboard";
import HomePage from "./components/HomePage";
import Login from "./components/loginsignup";
import Newsletter from "./components/newsletter";
import Podcast from "./components/podcast";
import Readmore from "./components/readmore";
import Sources from "./components/sources";

function App() {
  const { setSubscribeEmail, setUserlogin, setUserData } = appstore();
  const CustomCheckbox = styled(Button)(({ theme }) => ({
    color: theme.status.danger,
    "&.Mui-checked": {
      color: theme.status.danger,
    },
  }));
  const { menu } = appstore();
  const theme = createTheme({
    typography: {
      fontFamily: "Instrument Sans, Arial, sans-serif", // Add fallback fonts
    },
    palette: {
      // mode,
      primary: {
        main: "#C789E4",
        contrastText: "#ffffff", // Ensures text color is white when primary color is used
      },
      // background:"BBBBBB"
    },
  });
  useEffect(() => {
    if (window) {
      let check = localStorage.getItem("isSubscribed");
      setSubscribeEmail(check ? true : false);
      let userDetails = localStorage.getItem("userDetails");
      if (userDetails) {
        setSubscribeEmail(true);
        setUserData(JSON.parse(userDetails || "{}"));
        setUserlogin(true);
      }
    }
  }, []);
  return (
    <>
      <ToastContainer />
      <ThemeProvider theme={theme}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/newsletters" element={<Newsletter />} />
          <Route path="/readmore" element={<Readmore />} />
          <Route path="/podcast" element={<Podcast />} />
          <Route path="/sources" element={<Sources />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>{" "}
      </ThemeProvider>
    </>
  );
}
export default App;
{
  /* 
{/*

//  {/* <Box style={{ background: "#FCFBFC" }}> */
}
//           {/* {} */}
//             <Newsletter />
//           ) : menu == "Podcast" ? (
//             <Podcast />
//           ) : menu == "Sources" ? (
//             <Sources />
//           ) : (
//             <HomePage />
//           )}
//           </Box> */}
